
export const STORE_COUNTER = 'STORE_COUNTER';
export const CLEAR_COUNTER = 'CLEAR_COUNTER';